import * as isString from "lodash.isstring"
import { AGORA_VENDOR, MBS_VENDOR } from "../util/eventTypes"
export const getMediaEnterParams = (sdkTypes, authInfo) => {
  let enterParams
  if (sdkTypes === AGORA_VENDOR || MBS_VENDOR) {
    enterParams = {
      roomId: authInfo.roomId,
      userId: isString(authInfo.userId)
        ? parseInt(authInfo.userId)
        : authInfo.userId,
      role: isString(authInfo.userRole)
        ? parseInt(authInfo.userRole)
        : authInfo.userRole,
      type: "erizo",
      mediaConfiguration: "default"
    }
  } else if (sdkTypes === "vls") {
    let { appId } = authInfo
    let userRole
    if (authInfo.userRole === 1) {
      userRole = "teacher"
    }
    if (authInfo.userRole === 2) {
      userRole = "viewer"
    }
    enterParams = {
      room: authInfo.roomId,
      username: isString(authInfo.userId)
        ? authInfo.userId
        : JSON.stringify(authInfo.userId),
      role: userRole,
      appId
    }
    // 主辅流
    if (authInfo.roomprop) {
      enterParams.roomprop = authInfo.roomprop
    }
  }
  return enterParams
}
